import React from 'react';
import { InvoiceRecord } from '@types';

interface PdfViewerProps {
  invoice?: InvoiceRecord | null;
  pdfUrl: string | null;
  isLoadingPdf?: boolean;
}

export const PdfViewer: React.FC<PdfViewerProps> = ({
  invoice,
  pdfUrl,
  isLoadingPdf = false
}) => {
  return (
    <div className="w-full h-full bg-white flex flex-col">
      {/* Header - Fixed height */}
      <div className="flex-shrink-0 p-4 border-b border-secondary-200">
        <h2 className="text-lg font-semibold text-secondary-900">
          Invoice Document
        </h2>
      </div>
      
      {/* Content area - Flex to fill remaining space */}
      <div className="flex-1 p-4 min-h-0">
        {invoice?.pdf_filename ? (
          <div className="w-full h-full border border-secondary-300 rounded-lg overflow-hidden flex flex-col">
            {/* Warning banner - Fixed height */}
            <div className="flex-shrink-0 bg-warning-50 border-b border-warning-200 p-3">
              <p className="text-sm text-warning-800">
                <strong>Note:</strong> The PDF document is static and won't change when you edit the form fields above. 
                The form fields are metadata stored separately from the PDF file.
              </p>
            </div>
            
            {/* PDF content - Flex to fill remaining space */}
            <div className="flex-1 min-h-0">
              {isLoadingPdf ? (
                <div className="w-full h-full flex items-center justify-center bg-secondary-50">
                  <div className="text-center">
                    <div className="w-8 h-8 border-4 border-accent-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" role="status" aria-label="Loading PDF" />
                    <p className="text-secondary-500">Loading PDF...</p>
                  </div>
                </div>
              ) : pdfUrl ? (
                <iframe
                  src={`${pdfUrl}#zoom=100`}
                  className="w-full h-full border-0"
                  title="Invoice PDF"
                  style={{ minHeight: '600px' }}
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-secondary-50">
                  <div className="text-center">
                    <p className="text-secondary-500">PDF could not be loaded</p>
                    <p className="text-sm text-secondary-400">
                      There was an error loading the PDF file
                    </p>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="w-full h-full border border-secondary-300 rounded-lg flex items-center justify-center bg-secondary-50">
            <div className="text-center">
              <p className="text-secondary-500">No PDF file available</p>
              <p className="text-sm text-secondary-400">
                The invoice PDF file could not be loaded
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
